// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2QD33","approved":"Status_approved__1iU_H","rejected":"Status_rejected__1WfUU","expired":"Status_expired__1leuH","label":"Status_label__2nIvX"};